import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FaAngleDown, FaClipboardList } from 'react-icons/fa6';

const ClaimStatusDropdown = ({
  currentStatusLabel,
  currentStatusValue,
  reclamationId,
  onStatusChange,
  statusOptions,
  listHeight = 400,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen((prev) => !prev);

  const handleSelect = (value) => {
    setIsOpen(false);
    onStatusChange(reclamationId, value);
  };

  return (
    <div className="employee-dropdown-and-add-button claim-status">
      <Dropdown
        isOpen={isOpen}
        toggle={handleToggle}
        onClick={(e) => e.stopPropagation()}
        className="employee-name-dropdown"
      >
        <DropdownToggle>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <FaClipboardList size={20} />
            <span>{currentStatusLabel}</span>
            <FaAngleDown fill="#A0A0A3" />
          </span>
        </DropdownToggle>
        {isOpen && (
          <DropdownMenu
            className="dropdown-menu-right"
            right
            style={{
              maxHeight: listHeight ? `${listHeight}px` : '300px',
              overflowY: 'auto',
            }}
          >
            {statusOptions.map((option, i) => (
              <Fragment key={option.value}>
                {i !== 0 && <DropdownItem divider />}
                <DropdownItem
                  onClick={() => handleSelect(option.value)}
                  active={currentStatusValue === option.value}
                >
                  {option.label}
                </DropdownItem>
              </Fragment>
            ))}
          </DropdownMenu>
        )}
      </Dropdown>
    </div>
  );
};

ClaimStatusDropdown.propTypes = {
  currentStatusLabel: PropTypes.string.isRequired,
  currentStatusValue: PropTypes.number.isRequired,
  reclamationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onStatusChange: PropTypes.func.isRequired,
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  listHeight: PropTypes.number,
};

export default ClaimStatusDropdown;
